import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';

export const USER_PAGE_SIZES = [10, 50, 100];

const NAVIGATION = [
  { icon: ChevronsLeft, label: 'First page', target: () => 1 },
  { icon: ChevronLeft, label: 'Previous page', target: (page) => page - 1 },
  { icon: ChevronRight, label: 'Next page', target: (page) => page + 1 },
  { icon: ChevronsRight, label: 'Last page', target: (_page, pages) => pages },
];

function pageRange(total, page, pageSize) {
  if (total <= 0) return { start: 0, end: 0 };
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);
  return { start, end };
}

export function UserListPagination({
  total,
  page,
  pageSize,
  totalPages,
  onPageChange,
  onPageSizeChange,
  testIdPrefix = 'user-page',
}) {
  if (total <= 0) return null;

  const pages = Math.max(1, totalPages || 1);
  const { start, end } = pageRange(total, page, pageSize);

  return (
    <div className="mt-4 flex w-full flex-row items-center justify-between gap-3">
      <div className="flex items-center gap-2">
        <span className="text-xs text-slate-600 sm:text-sm">Rows Per Page:</span>
        <Select
          value={String(pageSize)}
          onValueChange={(value) => onPageSizeChange(Number(value))}
        >
          <SelectTrigger className="h-8 w-[72px]" data-testid={`${testIdPrefix}-size`}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {USER_PAGE_SIZES.map((size) => (
              <SelectItem key={size} value={String(size)}>
                {size}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center gap-2 sm:gap-3">
        <p className="whitespace-nowrap text-xs text-slate-600 sm:text-sm">
          <span className="font-medium">
            {start}-{end}
          </span>{' '}
          of <span className="font-medium">{total}</span>
        </p>
        <div className="flex items-center gap-1">
          {NAVIGATION.map(({ icon: Icon, label, target }, index) => {
            const disabled = (index < 2 && page <= 1) || (index >= 2 && page >= pages);
            return (
              <button
                key={label}
                type="button"
                aria-label={label}
                disabled={disabled}
                data-testid={`${testIdPrefix}-${label.toLowerCase().replace(' ', '-')}`}
                onClick={() => onPageChange(target(page, pages))}
                className="flex h-8 w-8 items-center justify-center rounded hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-40"
              >
                <Icon className="h-4 w-4" />
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
